module.exports = __webpack_public_path__ + "static/media/image (1).df8bc57d.png";